module.exports = __webpack_public_path__ + "static/media/bed.803079f9.png";